import {promisifyTimeout} from '@exadel/esl/modules/esl-utils/async/promise';
import {isAEMAuthorMode} from 'core/helpers/aem';
import {HPEAssetViewerLinkMixin} from 'core/asset-viewer-link-mixin';
import {HPEAssetViewerModalShared} from 'core/asset-viewer-modal-shared';

export default {
  initialize: async (): Promise<void> => {
    if (isAEMAuthorMode()) return;
    // split to separate macrotask
    await promisifyTimeout(0);
    HPEAssetViewerLinkMixin.register();
    await HPEAssetViewerModalShared.init();
  }
};
